<span
	class="line-clamp-1 text-ellipsis whitespace-normal break-all"
	[class]="styleClass()"
	directiveIsEllipsis
	#ellipsis="isEllipsis"
	[uiTooltip]="ellipsis.isEllipsed ? label() : ''"
>
	{{ label() }}
</span>
